<template>
    <div>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <b-card class="sa-card sa-card-border" header="Scuola e Lavoro" header-tag="header" footer-tag="footer" title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <label class="sa-label-data">Titolo di studio:</label>
                            <span v-if="isReadOnly">{{ jsonDataScuolaLavoro.titoloStudio }}</span>
                            <b-form-textarea v-else v-model="jsonDataScuolaLavoro.titoloStudio" :readonly="isReadOnly" max-rows="3" rows="1"> </b-form-textarea>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <label class="sa-label-data">Situazione lavorativa:</label>
                            <span v-if="isReadOnly">{{ jsonDataScuolaLavoro.situazioneLavorativa }}</span>
                            <b-form-textarea v-else v-model="jsonDataScuolaLavoro.situazioneLavorativa" :readonly="isReadOnly" max-rows="3" rows="1"> </b-form-textarea>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <label class="sa-label-data">Note sulla situazione lavorativa:</label>
                            <span v-if="isReadOnly">{{ jsonDataScuolaLavoro.noteSituazioneLavorativa }}</span>
                            <b-form-textarea v-else v-model="jsonDataScuolaLavoro.noteSituazioneLavorativa" :readonly="isReadOnly" max-rows="3" rows="1"> </b-form-textarea>
                        </b-col>
                    </b-row>
                    <div class="d-flex justify-content-end">
                        <b-button v-if="!isReadOnly && jsonDataScuolaLavoro.id" @click="onSaveScuolaLavoro"  variant="outline-success">Salva</b-button>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    props: {
        isReadOnly: {
            type: Boolean,
            default: false,
        },
        idAccettazione: {
            type: String,
        },
        jsonDataScuolaLavoro: {
            type: Object,
            default: function () {
                return {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    titoloStudio: "",
                    situazioneLavorativa: "",
                    noteSituazioneLavorativa: "",
                };
            },
        },
    },
    mixins: [UtilityMixin],
    watch: {
        jsonDataScuolaLavoro: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    data() {
        return {
            pathResourceSchedaRelazioneSanitariaScuolaLavoro: "/rsaschedarelazionesanitariascuolalavoro",
        };
    },
    methods: {
        loadSchedaRelazioneSanitariaScuolaLavoro() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceSchedaRelazioneSanitariaScuolaLavoro + "/accettazione/" + me.idAccettazione, {}, me.resultResponseSchedaRelazioneSanitariaScuolaLavoroSuccess, me.resultResponseSchedaRelazioneSanitariaScuolaLavoroError);
        },

        resultResponseSchedaRelazioneSanitariaScuolaLavoroSuccess(response) {
            let me = this;
            me.jsonDataScuolaLavoro = response.data.data;
        },

        resultResponseSchedaRelazioneSanitariaScuolaLavoroError(error) {
            let me = this;
            if (error.response && error.response.status === 404) {
                me.resetForm();
            }
        },

        resetForm() {
            let me = this;
            me.jsonDataScuolaLavoro = {
                id: null,
                idAccettazione: this.idAccettazione,
                titoloStudio: "",
                situazioneLavorativa: "",
                noteSituazioneLavorativa: "",
            };
        },

        onSaveScuolaLavoro() {
            let me = this;
            me.jsonDataScuolaLavoro.idAccettazione = me.idAccettazione;
            if (!me.jsonDataScuolaLavoro.idAccettazione) {
                me.$bvToast.toast("Errore: ID Accettazione mancante", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
                return;
            }
            UtilityMixin.methods.saveResource(me.pathResourceSchedaRelazioneSanitariaScuolaLavoro, me.jsonDataScuolaLavoro, me.saveSchedaRelazioneSanitariaScuolaLavoroSuccessResponse, me.saveSchedaRelazioneSanitariaScuolaLavoroErrorResponse);
        },
        saveSchedaRelazioneSanitariaScuolaLavoroSuccessResponse() {
            let me = this;
            me.$bvToast.toast("Scuola e lavoro salvati con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
            me.$parent.loadData();
        },
        saveSchedaRelazioneSanitariaScuolaLavoroErrorResponse() {
            console.error("Errore nel salvataggio scuola e lavoro :");
        },
    },
};
</script>
